import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Artikelgroep } from '../dto/artikelgroep';
import { CrudService } from '@mango/core';

@Injectable({ providedIn: 'root' })
export class ArtikelgroepService extends CrudService<Artikelgroep> {

    constructor(injector: Injector) { super(Artikelgroep, injector); }

}
